import { Box, Stack, Typography, useTheme } from '@mui/material';
import moment from 'moment';

import { IcClock, IcPencil } from '@/assets/images';
import { DateTimePicker } from '@/components';
import { DATE_TIME_FORMAT } from '@/config';

interface CFSReporterTimeItemProps {
  label?: string;
  reporterTime?: string;
  onAccept?: (newDateTime: string) => void;
}

export const CFSReporterTimeItem = ({
  label,
  reporterTime,
  onAccept,
}: CFSReporterTimeItemProps) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        gap: 1,
        minHeight: '20px',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <IcClock color={theme.palette.text.primary} height={20} />
        {label && (
          <Typography color={theme.palette.text.secondary} variant="body2">
            {label}:
          </Typography>
        )}
        <Typography color={theme.palette.text.primary} variant="body2">
          {moment(reporterTime).format(DATE_TIME_FORMAT)}
        </Typography>
      </Stack>

      {!!onAccept && (
        <Box sx={{ height: 32, width: 32 }}>
          <DateTimePicker
            pickerIcon={<IcPencil />}
            value={reporterTime ? moment(reporterTime) : null}
            onAccept={(v) => onAccept(moment(v).toISOString())}
            hideInput
          />
        </Box>
      )}
    </Stack>
  );
};
